/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M13.5 9V15H14.5C15.4319 15 15.8978 15 16.2654 14.8478C16.7554 14.6448 17.1448 14.2554 17.3478 13.7654C17.5 13.3978 17.5 12.9319 17.5 12V12C17.5 11.0681 17.5 10.6022 17.3478 10.2346C17.1448 9.74458 16.7554 9.35523 16.2654 9.15224C15.8978 9 15.4319 9 14.5 9H13.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M13.5 9V15H14.5C16.1569 15 17.5 13.6569 17.5 12V12C17.5 10.3431 16.1569 9 14.5 9H13.5ZM10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM14.5 9.75C14.9762 9.75 15.2958 9.75041 15.5433 9.76729C15.784 9.78372 15.9012 9.81319 15.9784 9.84515C16.2846 9.97202 16.528 10.2154 16.6548 10.5216C16.6868 10.5988 16.7163 10.716 16.7327 10.9567C16.7496 11.2042 16.75 11.5238 16.75 12C16.75 12.4762 16.7496 12.7958 16.7327 13.0433C16.7163 13.284 16.6868 13.4012 16.6548 13.4784C16.528 13.7846 16.2846 14.028 15.9784 14.1549C15.9012 14.1868 15.784 14.2163 15.5433 14.2327C15.2958 14.2496 14.9762 14.25 14.5 14.25H14.25V9.75H14.5ZM16.5524 8.45933C16.262 8.33905 15.9625 8.29241 15.6454 8.27077C15.3408 8.24999 14.9697 8.24999 14.5253 8.25H14.5H13.5C13.0858 8.25 12.75 8.58579 12.75 9V15C12.75 15.4142 13.0858 15.75 13.5 15.75H14.5H14.5253C14.9697 15.75 15.3408 15.75 15.6454 15.7292C15.9625 15.7076 16.262 15.661 16.5524 15.5407C17.2262 15.2616 17.7616 14.7262 18.0407 14.0524C18.161 13.762 18.2076 13.4625 18.2292 13.1454C18.25 12.8408 18.25 12.4697 18.25 12.0253V12V11.9747C18.25 11.5303 18.25 11.1592 18.2292 10.8546C18.2076 10.5375 18.161 10.238 18.0407 9.94762C17.7616 9.27379 17.2262 8.73844 16.5524 8.45933ZM7.75 9C7.75 8.58579 7.41421 8.25 7 8.25C6.58579 8.25 6.25 8.58579 6.25 9V12V15C6.25 15.4142 6.58579 15.75 7 15.75C7.41421 15.75 7.75 15.4142 7.75 15V12.75H10.25V15C10.25 15.4142 10.5858 15.75 11 15.75C11.4142 15.75 11.75 15.4142 11.75 15V12V9C11.75 8.58579 11.4142 8.25 11 8.25C10.5858 8.25 10.25 8.58579 10.25 9V11.25H7.75V9Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M13.5 9V15H14.5C16.1569 15 17.5 13.6569 17.5 12V12C17.5 10.3431 16.1569 9 14.5 9H13.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7 9V12M7 12V15M7 12H11M11 12V9M11 12V15M13.5 9V15H14.5C16.1569 15 17.5 13.6569 17.5 12V12C17.5 10.3431 16.1569 9 14.5 9H13.5ZM10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.5433 9.76729C15.2958 9.75041 14.9762 9.75 14.5 9.75H14.25V14.25H14.5C14.9762 14.25 15.2958 14.2496 15.5433 14.2327C15.784 14.2163 15.9012 14.1868 15.9784 14.1549C16.2846 14.028 16.528 13.7846 16.6548 13.4784C16.6868 13.4012 16.7163 13.284 16.7327 13.0433C16.7496 12.7958 16.75 12.4762 16.75 12C16.75 11.5238 16.7496 11.2042 16.7327 10.9567C16.7163 10.716 16.6868 10.5988 16.6548 10.5216C16.528 10.2154 16.2846 9.97202 15.9784 9.84515C15.9012 9.81319 15.784 9.78372 15.5433 9.76729ZM15.6454 8.27077C15.9625 8.29241 16.262 8.33905 16.5524 8.45933C17.2262 8.73844 17.7616 9.27379 18.0407 9.94762C18.161 10.238 18.2076 10.5375 18.2292 10.8546C18.25 11.1592 18.25 11.5303 18.25 11.9747V12V12.0253C18.25 12.4697 18.25 12.8408 18.2292 13.1454C18.2076 13.4625 18.161 13.762 18.0407 14.0524C17.7616 14.7262 17.2262 15.2616 16.5524 15.5407C16.262 15.661 15.9625 15.7076 15.6454 15.7292C15.3408 15.75 14.9697 15.75 14.5253 15.75H14.5H13.5C13.0858 15.75 12.75 15.4142 12.75 15V9C12.75 8.58579 13.0858 8.25 13.5 8.25H14.5L14.5253 8.25C14.9697 8.24999 15.3408 8.24999 15.6454 8.27077ZM7 8.25C7.41421 8.25 7.75 8.58579 7.75 9V11.25H10.25V9C10.25 8.58579 10.5858 8.25 11 8.25C11.4142 8.25 11.75 8.58579 11.75 9V12V15C11.75 15.4142 11.4142 15.75 11 15.75C10.5858 15.75 10.25 15.4142 10.25 15V12.75H7.75V15C7.75 15.4142 7.41421 15.75 7 15.75C6.58579 15.75 6.25 15.4142 6.25 15V12V9C6.25 8.58579 6.58579 8.25 7 8.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
